var exports = {
  "l": "Faq__jOVGQG",
};

module.exports = exports;
